import React from 'react';
import { HelpCircle } from 'lucide-react';
export function EmpathySection() {
  const questions = ['Why does cash feel tight even in our highest-revenue months?', 'Which of our services or customers are actually driving profit, and which are draining it?', 'Can we safely afford to hire, expand, or buy new equipment right now?', 'What is my business actually worth today—and what would a buyer flag as a risk?'];
  return <section className="w-full py-24 sm:py-32 px-6 sm:px-8 bg-slate-100" data-id="element-128">
      <div className="max-w-6xl mx-auto" data-id="element-129">
        <div className="max-w-3xl mb-16" data-id="element-130">
          <p className="text-gold-500 text-sm font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-131">
            The Questions Keeping You Up
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-navy-900 mb-6 leading-tight" data-id="element-132">
            Strategic growth requires more than just clean books.
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-133">
            If you've found yourself asking these questions, you've outgrown
            traditional bookkeeping:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-134">
          {questions.map((question, index) => <div key={index} className="bg-white p-8 rounded-lg border border-slate-200 hover:border-gold-500/30 hover:shadow-card-hover transition-all duration-300" data-id="element-135">
              <div className="flex items-start gap-4" data-id="element-136">
                <div className="w-10 h-10 rounded-full bg-navy-900/5 flex items-center justify-center flex-shrink-0" data-id="element-137">
                  <HelpCircle size={20} className="text-navy-900" data-id="element-138" />
                </div>
                <p className="text-navy-900 text-lg font-medium leading-relaxed pt-1.5" data-id="element-139">
                  "{question}"
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}